import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/footer-ready.png'
import _imports_1 from '../images/footer-contact.png'
import _imports_2 from '../images/footer-contact-active.png'
import _imports_3 from '../images/footer-logo.png'
import _imports_4 from '../images/up-icon.png'
import _imports_5 from '../images/logo-twitter.png'
import _imports_6 from '../images/logo-alibaba.png'
import _imports_7 from '../images/logo-youtube.png'
import _imports_8 from '../images/logo-email.png'
import _imports_9 from '../images/logo-facebook.png'


const _withScopeId = n => (_pushScopeId("data-v-aab16480"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-box-one" }
const _hoisted_3 = { class: "one-main" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-con" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Ready to grow your business?"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "footer icon"
  })
], -1))
const _hoisted_5 = { class: "footer-box-two" }
const _hoisted_6 = { class: "two-main" }
const _hoisted_7 = { class: "logo-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_3,
  alt: "otimes footer logo"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "LINKS", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "up-icon"
}, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "mation-con" }
const _hoisted_13 = { class: "mation-left" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " One-stop plastic raw material and steel sheets sales service platform ", -1))
const _hoisted_15 = { class: "logo-link" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "otimes twitter"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "otimes alibaba"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "otimes logo-youtube"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "otimes email"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: "otimes facebook"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"mation-middle\" data-v-aab16480><div class=\"mation-main\" data-v-aab16480><p class=\"title\" data-v-aab16480>Shenzhen Headquarter :</p><p class=\"content\" data-v-aab16480> 5603,Building ONE, Qianhai Excellence Center, Qianhai Shenzhen-Hong Kong Cooperation Zone, Shenzhen </p></div><div class=\"mation-main\" data-v-aab16480><p class=\"title\" data-v-aab16480>Tel :</p><p class=\"content\" data-v-aab16480>0755-83227395</p></div><div class=\"mation-main\" data-v-aab16480><p class=\"title\" data-v-aab16480>Mail :</p><p class=\"content\" data-v-aab16480>ws@otimes.com</p></div><div class=\"mation-main\" data-v-aab16480><p class=\"title\" data-v-aab16480>Hefei Office :</p><p class=\"content\" data-v-aab16480> Intersection of Ningxi road and Changning Avenue, Hefei </p></div></div><div class=\"mation-right\" data-v-aab16480><div class=\"mation-main\" data-v-aab16480><p class=\"title\" data-v-aab16480>Foshan Office :</p><p class=\"content\" data-v-aab16480> No. 1, Malong Longchuang Road, Beijiao Town, Shunde District, Foshan </p></div><div class=\"mation-main\" data-v-aab16480><p class=\"title\" data-v-aab16480>Suzhou Office :</p><p class=\"content\" data-v-aab16480> Zhonghai Longwan, Wuyun Road, Xiangcheng District, Suzhou </p></div><div class=\"mation-main\" data-v-aab16480><p class=\"title\" data-v-aab16480>Wuxi Office :</p><p class=\"content\" data-v-aab16480> Building A, Zhongchu Metal Market, Xinwu District, Wuxi </p></div><div class=\"mation-main\" data-v-aab16480><p class=\"title\" data-v-aab16480>Singapore Office :</p><p class=\"content\" data-v-aab16480> 331 North Bridge Road #22 01/06, Odeon Towers Singapore 188720 </p></div></div>", 2)
const _hoisted_23 = { class: "footer-box-three" }
const _hoisted_24 = { class: "three-main" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Copyright"),
  /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "©"),
  /*#__PURE__*/_createTextVNode(" Eight Element Environment Technology Co, Ltd(Otimes). All Rights Reserved "),
  /*#__PURE__*/_createElementVNode("span", { class: "none" }, "经营许可证号："),
  /*#__PURE__*/_createElementVNode("a", {
    class: "none",
    href: "https://beian.miit.gov.cn/",
    target: "_blank"
  }, "粤ICP备18127995号-4")
], -1))
const _hoisted_26 = { class: "link-box" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "split" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "split" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "split" }, null, -1))
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"main\" data-v-aab16480><ul class=\"link-con\" data-v-aab16480><li class=\"link-go\" data-v-aab16480><a href=\"https://cn.otimes.net/\" target=\"_blank\" data-v-aab16480>OTIMES in Chinese</a></li><li class=\"link-go\" data-v-aab16480><a href=\"https://www.otimes.net/\" target=\"_blank\" data-v-aab16480>OTIMES in English</a></li><li class=\"link-go\" data-v-aab16480><a href=\"https://www.otimes.com/\" target=\"_blank\" data-v-aab16480>E-MARKET</a></li></ul></div>", 1)
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_link, { underline: false }, {
          default: _withCtx(() => [
            (_ctx.contactTag == 1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.contactTag = 2)),
                  src: _imports_1,
                  alt: "otimes contact us"
                }, null, 32))
              : _createCommentVNode("", true),
            (_ctx.contactTag == 2)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.contactTag = 1)),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/career.html'))),
                  src: _imports_2,
                  alt: "otimes contact us"
                }, null, 32))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", {
            class: "link-box",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.linkTag = 1))
          }, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_link, {
                underline: false,
                href: "https://twitter.com/Otimes11",
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }),
              _createVNode(_component_el_link, {
                underline: false,
                href: "https://otimes.en.alibaba.com",
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }),
              _createVNode(_component_el_link, {
                underline: false,
                href: "https://www.youtube.com/channel/UC6yK4X18rd0h1xKDhkYs8-w",
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }),
              _createVNode(_component_el_link, {
                underline: false,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/career.html')))
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }),
              _createVNode(_component_el_link, {
                underline: false,
                href: "https://www.facebook.com/Eighth-Element-Environment-Technology-Co-Ltd-100322925983089",
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_21
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", {
            class: "link-tab",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/')))
          }, "HOME"),
          _hoisted_27,
          _createElementVNode("span", {
            class: "link-tab",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/about.html')))
          }, "ABOUT US"),
          _hoisted_28,
          _createElementVNode("span", {
            class: "link-tab",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push('/cookie.html')))
          }, "COOKIE POLICY"),
          _hoisted_29,
          _createElementVNode("span", {
            class: "link-tab",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push('/career.html')))
          }, "CONTACT US")
        ])
      ])
    ]),
    (_ctx.linkTag)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "link-mask",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.linkTag = 0))
        }, _hoisted_31))
      : _createCommentVNode("", true)
  ]))
}